/**
 * @description 全局Model followModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import { APIS } from '@src/services';
import { ParamsBodyuserFollowUsingPost } from '@src/services/api/UserApi';
import { ParamsgroupsGroupIdJoinUsingPost } from '@src/services/api/GroupApi';
import { ParamsteamsTeamIdFollowUsingPost } from '@src/services/api/TeamApi';
import * as models from '@services/model/models';
import { message } from 'antd';

export interface State {
  followModel: {};
}

export const followModelState: State = {
  followModel: {}
};

const model = createModel({
  state: followModelState,
  namespace: 'followModel',
  reducers: {},
  effects: {
    // 关注/取关用户
    *userFollow(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsBodyuserFollowUsingPost;
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { callBack, params } = action.payload;
      const res = yield tCall(APIS.UserApi.userFollowUsingPost, action.payload.params);
      if (res.code === 0) {
        callBack && callBack(res);
        message.success(`${params.ifFollow ? '已关注' : '已取消关注'}`);
      } else {
        message.error(res.message);
      }
    },
    // 加入或者退出圈子
    *groupJoin(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdJoinUsingPost;
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { callBack, params } = action.payload;
      const res = yield tCall(APIS.GroupApi.groupsGroupIdJoinUsingPost, action.payload.params);
      if (res.code === 0) {
        callBack && callBack(res);
      } else {
        message.error(res.message);
      }
    },
    // 关注或取关团队
    *teamFollow(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsteamsTeamIdFollowUsingPost;
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { callBack, params } = action.payload;
      const res = yield tCall(APIS.TeamApi.teamsTeamIdFollowUsingPost, action.payload.params);
      if (res.code === 0) {
        callBack && callBack(res);
        message.success(`${params.follow ? '已关注' : '已取消关注'}`);
      } else {
        message.error(res.message);
      }
    }
  }
});

export default model;
